import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import { Dropdown, Icon } from "@devowl-wp/react-folder-tree";
import { useStores } from "../../store/rootStore.js";
/**
 * Create a tax switcher if more than one taxonomy is available for the post type.
 */ const TaxSwitcher = ({ disabled })=>{
    if (process.env.PLUGIN_CTX === "pro") {
        const { optionStore } = useStores();
        const { others: { taxos, taxnow } } = optionStore;
        const handleTaxSwitch = useCallback(({ key })=>optionStore.setTaxnow(key), [
            optionStore
        ]);
        const keys = Object.keys(taxos);
        if (keys.length < 1) {
            return null;
        }
        return /*#__PURE__*/ _jsx(Dropdown, {
            placement: "bottomRight",
            disabled: disabled,
            menu: {
                items: keys.map((key)=>({
                        key,
                        label: taxos[key]
                    })),
                onClick: handleTaxSwitch,
                selectedKeys: [
                    taxnow
                ]
            },
            children: /*#__PURE__*/ _jsxs("a", {
                className: "ant-dropdown-link",
                style: {
                    textDecoration: "none",
                    cursor: "pointer"
                },
                children: [
                    taxos[taxnow],
                    " ",
                    /*#__PURE__*/ _jsx(Icon, {
                        type: "down"
                    })
                ]
            })
        });
    } else {
        return null;
    }
};
export { TaxSwitcher };
